export const translations =  {
    en: {
      message: {
        navi: {
          home: 'Home',
          contact: 'Contact',
          skills: 'Skills'
        },
        me1: 'I assume agile roles since 2010. As a developer first, since 2013 as Scrum Master, Product Owner, Business Analyst and Agile Coach. I strive for creating robust, self-organized teams, that work cross-functional, take ownership, operate in DevOps mode and implement end to end.<br>I have a bootstrapper, shaper and planter mentality with entrepreneurial background and an agile growth mindset. I work at a high pace with a passionate aggression and a strong bias for action and delivery. I face change & complexity with structure & methodology. I can zoom out to the big picture und zoom in into details.',
        me2: 'There are many great tools, techniques and formats, that can help to make a project successful, a process more efficient, a team more performant.',
        procedure: {
          header: 'Process and Goals',
          body: 'I analyse your product, get a shared understanding of the requirements, the budget and the resources. I work out a vision and mission statements, along which we shape your product and put it on a roadmap with achievable milestones that generate value. We go as soon as possible productive in order to get valid feedback from the market. We move on driven by user data and customer feedback. We build a flexible architecture. I support the team build with the goal to build a team with a shared mental model, that acts self-organized and in full transparence.'
        },
        requirements: {
          header: 'Requirements and backlog',
          body: '<ul><li>Storymapping</li><li>Impact Mapping</li><li>Event Storming</li><li>Customer Journey</li><li>Definition of Prototype, MVP, MMP, Epics, Feature, Stories</li></li><li>Whatever fits the requirements ...</li></ul>'
        },
        prioritization: {
          header: 'Prioritization and estimatation',
          body: '<ul><li>Prioritization and estimation techniques, e.g. Planning Poker, Magic Estimation, Stacey Diagram, Kano Model</li></ul>'
        },
        project: {
          header: 'Project',
          body: '<ul><li>Introduce Scrum, Kanban and XP</li><li>Facilitate rituals and formats</li><li>Scale teams</li><li>Establish DevOps</li></ul>'
        },
        multiProject: {
          header: 'Multi-project, multi-team structur',
          body: '<ul><li>Scale projects and teams</li><li>Start frameworks as Less, Safe or Nexus </li></ul>'
        },
        organization: {
          header: 'Organisation and business strategy',
          body: '<ul><li>Create and break down epic and feature portfolio</li><li>Create a Value Proposition Canvas, Lean Canvas</li><li>Write your vision and mission statement</li><li>Define goals and metrics</li><li>Introduce agile principles globaly (e.g. with OKR)</li></ul>'
        },
        metrics: {
          header: 'Metrics',
          body: '<p>Don\'t wast your time with vanity metrics and useless statistics. Focus on:</p><ul><li>Leading indicators</li><li>Actionable metrics</li></ul>'
        },
        architecture: {
          header: 'Architecture, technical strategy',
          body: '<ul><li>ATAM</li><li>Set up a technology radar</li><li>Create benchmark</li></ul>'
        },
        teams: {
          header: 'Teams',
          body: '<ul><li>Team building</li><li>Create flow</li><li>Introduce continuous learning and know-how sharing on individual, team or company level</li><li>Start and document a team agreement</i></li><li>Evaluate and raise the maturity levelof a team</li></ul>'
        },
        workshops: {
          header: 'Workshops and Offsites',
          body: 'We offer workshops and off-sites on-site or off-site. We define scope and agenda of a workshop. We can also chose open agenda and open space as a format.'
        },
        assessment: {
          header: 'Assessment',
          body: 'We can run assessments for the roles Scrum Master and Product Owner. We have different ways of starting a dialogue around agile topics.'
        },
        blog: {
          header: 'Blog',
          link1: 'Blogs at Mayflower',
          link2: 'Blogs on Blogspot'
        },
        contact: {
          header: 'Contact',
          contact: 'Micha Trieba | Weipertshausen 11 | 82541 Münsing | Tel. +49 163-479 37 33'
        },
        responsible: {
          header: 'Responsible for content',
          contact: 'Micha Trieba | Weipertshausen 11 | 82541 Münsing | Tel. +49 163-479 37 33'
        }
      }
    },
    de: {
      message: {
        navi: {
          home: 'Home',
          contact: 'Kontakt',
          skills: 'Können'
        },
        me1: 'Ich arbeite seit 2006 auf IT Projekten als Projektleiter und Entwickler, seit 2013 in den Rollen Scrum Master, Product Owner, Business Analyst und Agile Coach. Ich bin rigoros und strikt in der Sache, aber flexibel in den Methoden und sensibel für den Kontext. Ich strebe nach robusten, selbstorganisierten, verantwortungsbewussten Teams, die <i>cross-functional</i> arbeiten, im DevOps Modus handeln und <i>end to end</i> implementieren. Ich sehe mich als <i>Bootstraper</i> und Gestalter mit Unternehmergeist und einem <i>Growth Mindset</i>. Ich fühle mich wohl in einem schnellen Umfeld und agiere mit leidenschaftlicher Aggression und einem starken Drang zur Umsetzung und Lieferung.',
        me2: 'An vielen Stellen helfen Werkzeuge aus dem agilen Arbeiten, um Team und Organisation zu verbessern, Teams schneller, und Prozesse geschmeidiger zu machen. Ich habe Erfahrung mit Scrum, Kanban und den skalierenden <i>Frameworks</i> wie Nexus, Safe oder Less.',
        procedure: {
          header: 'Vorgehen und Ziele',
          body: 'Gemeinsam analysieren wir dein Produkt, verstehen deine Anforderungen, dein Budget, dein Ressourcen. Wir formulieren deine Vision und arbeiten passende <i>Mission Statements</i> aus. Wir modellieren dein Produkt und geben der Umsetzung eine klare Richtung sowie machbare, Mehrwert erzeugende Meilensteine auf einer Roadmap. Wir erreichen so schnell wie möglich den Markt und deine zukünftigen Nutzer, um die Entwicklung entlang von Feedback und Nutzerdaten voranzutreiben. Wir arbeiten emergent und schärfen das Naheliegende. Wir bauen eine flexible Architektur und bilden ein Team, das motiviert und schnell ist. Dein Projekt bekommt eine Struktur zum anfassen und anschauen, klare Konturen und konsistente Anforderungen. Wir bauen auf eine transparente Kollaboration mit Verantwortung und Selbstorganisation. Wir streben ein gemeinsames mentales Modell an, das von Vertrauen und Planbarkeit getragen wird. <p>Wir nutzen Tools, Methoden, Formate und Techniken, die uns helfen, das große Ganze zu verstehen, es in kleine Inkremente herunterzubrechen und diese in der richtigen Reihenfolge zu implementieren.</p>'
        },
        requirements: {
          header: 'Requirements und Backlog',
          body: '<ul><li>Storymapping</li><li>Impact Mapping</li><li>Event Storming</li><li>Customer Journey</li><li>Definition von<i>Prototype, MVP, MMP, Epics, Feature, Stories</i></li><li>... was am besten zum Project passt</li></ul>'
        },
        prioritization: {
          header: 'Priorisieren und schätzen',
          body: '<ul><li>Techniken zur Priorisierung & zum Schätzen, z.B. <i>Planning Poker</i>, <i>Magic Estimation</i>, <i>Stacey Diagram</i>, <i>Kano Modell</i></li></ul>'
        },
        project: {
          header: 'Project',
          body: '<ul><li>Scrum, Kanban and XP einführen</li><li>Rituale und Formate moderieren</li><li>Teams skalieren</li><li>DevOps etablieren</li></ul>'
        },
        multiProject: {
          header: 'Multi-Projekt, Multi-Team',
          body: '<ul><li>Projekte und Teams skalieren</li><li><i>Frameworks</i> wie <i>Less</i>, <i>Safe</i> oder <i>Nexus</i> an den Start bringen</li></ul>'
        },
        organization: {
          header: 'Organisation und Strategie',
          body: '<ul><li>Anforderungs und <i>Feature Portfolio</i> erstellen und runterbrechen</li><li><i>Value Proposition Canvas</i>, <i>Lean Canvas</i> erstellen</li><li>Vision und <i>Mission Statement</i> schreiben</li><li>Ziele und messbare Ergebnisse aufstellen</li><li>Global agiles Arbeiten einführen (z.B. mit <i>OKR</i>)</li></ul>'
        },
        metrics: {
          header: 'Metriken',
          body: '<p>Zeit in die richtigen Metriken und Statistiken investieren: </p><ul><li><i>Leading indicators</i></li><li><i>Actionable metrics</i></li></ul>'
        },
        architecture: {
          header: 'Architektur, Strategie',
          body: '<ul><li>ATAM durchführen</li><li>Workshops planen und umsetzen</li><li><i>Technologie Radar</i> etablieren</li><li>Benchmark erstellen</li></ul>'
        },
        teams: {
          header: 'Teams',
          body: '<ul><li><i>Flow</i> erzeugen</li><li>Grundlagen für kontinuierliches Lernen und Wissensaustausch schaffen auf persönlicher, Team und Unternehmensebene,</li><li>Teambuilding fördern</li><li><i>Team Agreement</i> erreichen und dokumentieren</li>      <li>Maturity Level bestimmen und verbessern</li></ul>'
        },
        workshops: {
          header: 'Workshops and Offsites',
          body: 'Ich biete Workshops vor Ort und Offsites in der Uckermark (17268 Mittenwalde) an. Wir definieren im Vorfeld Umfang und Inhalte und erstellen eine Agenda. Gerne auch mit <i>Open Agenda</i> oder als <i>Open Space</i>.'
        },
        assessment: {
          header: 'Unterstützung beim Assessment',
          body: 'Ich kann beim Assessment für die Rollen Scrum Master und Product Owner unterstützen. Ich gehe verschiedene Wege, um in den Dialog zu kommen und gemeinsam den Wissens- und Erfahrungshorizont abzustecken. Ich empfehle, im Vorfeld ein Team Canvas zu machen, um eine Vergleichsbasis zu haben. Wir können auch beim Assessment anderer Rollen Unterstützung bieten und z.B. Team-fähigkeit und agiles Arbeiten prüfen.'
        },
        blog: {
          header: 'Blogbeiträge',
          link1: 'Blogs bei Mayflower',
          link2: 'Blogs auf Blogspot'
        },
        contact: {
          header: 'Kontakt',
          contact: 'Micha Trieba | Weipertshausen 11 | 82541 Münsing | Tel. +49 163-479 37 33'
        },
        responsible: {
          header: 'Verantwortlich für die Inhalte auf diese Seite',
          contact: 'Micha Trieba | Weipertshausen 11 | 82541 Münsing | Tel. +49 163-479 37 33'
        }

      }
    }
}
